













































import Component from 'vue-class-component';
import Vue from 'vue';
import TicketDataTable from '@/modules/tickets/dashboard/components/TicketDataTable.vue';
import { ticketsDashboard } from '@/modules/shared/shared/store/namespaces';
import {
    TICKET_DASHBOARD_GET_PAGES,
    TICKET_DASHBOARD_GET_TABULATED_TICKETS,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.getters';
import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';
import { getStatusFilter } from '@/modules/tickets/dashboard/store/tickets-dashboard.functions';
import {
    TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS,
    TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER,
    TICKETS_DASHBOARD_GET_TICKETS,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.actions';

@Component({
    components: { TicketDataTable },
})
export default class TicketsTable extends Vue {
    elevation: number = 1;
    limit: number = 20;
    page: number = 1;
    filters: { id: number; name: string; type: string; color: string }[] = [];
    headers: {}[] = [
        { text: 'Ticket', value: 'serial', align: 'center', sortable: false },
        { text: 'Descripción', value: 'type', align: 'start', sortable: false },
        { text: 'Fecha', value: 'date', align: 'center', sortable: false },
        { text: 'Estado', value: 'state', align: 'center', sortable: false },
    ];

    @ticketsDashboard.Getter(TICKET_DASHBOARD_GET_TABULATED_TICKETS)
    TICKET_DASHBOARD_GET_TABULATED_TICKETS;

    @ticketsDashboard.Action(TICKETS_DASHBOARD_GET_TICKETS)
    TICKETS_DASHBOARD_GET_TICKETS;

    @ticketsDashboard.Action(TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS)
    TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS;

    @ticketsDashboard.Action(TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER)
    TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER;

    @ticketsDashboard.Getter(TICKET_DASHBOARD_GET_PAGES)
    TICKET_DASHBOARD_GET_PAGES;

    get isLoading() {
        const isLoading: boolean = !this.tickets;

        this.elevation = isLoading ? 1 : 0;

        return !this.tickets;
    }

    get tickets() {
        return this.TICKET_DASHBOARD_GET_TABULATED_TICKETS;
    }

    get pages() {
        return this.TICKET_DASHBOARD_GET_PAGES;
    }

    getItemsPerPage(value: number) {
        this.limit = value;
        this.page = 1;

        if (this.filters.length < 1) {
            this.TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS({
                start: this.page,
                limit: this.limit,
            });
        } else {
            this.getFiltersTicketMenu(this.filters);
        }
    }

    getFiltersTicketMenu(data: { id: number; name: string; type: string; color: string }[]) {
        this.filters = data;
        const company: any = localStorage.getItem('company');
        let type: string = '';
        let statusFilters: {
            open: string;
            solve: string;
            close: string;
        } = getStatusFilter(this.$store.state.filters);
        let status: string = '';
        let date: string[] = [];
        let startDate: string = '';
        let endDate: string = '';

        if (!data !== undefined) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].type == 'T') {
                    if (type == '') {
                        type = '&ticketType=' + data[index].id;
                    } else {
                        type = type + '&ticketType=' + data[index].id;
                    }
                } else if (data[index].type == 'E') {
                    if (data[index].id == 1) {
                        status = status + statusFilters.open;
                    } else if (data[index].id == 7) {
                        status = status + statusFilters.solve;
                    } else if (data[index].id == 2) {
                        status = status + statusFilters.close;
                    }
                } else if (data[index].type == 'D') {
                    date = data[index].name.split(' ', 3);
                    startDate = '&startDate=' + date[0];
                    endDate = '&endDate=' + date[2];
                }
            }

            this.TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER({
                customerid: JSON.parse(company).id,
                limit: this.limit,
                start: this.page,
                type: type,
                status: status,
                startDate: startDate,
                endDate: endDate,
            });
        } else {
            this.TICKETS_DASHBOARD_GET_TICKETS();
            this.TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS({
                start: this.page,
                limit: this.limit,
            });
        }
    }

    changePage() {
        if (this.filters.length < 1) {
            const company: any = localStorage.getItem('company');
            this.TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS({
                start: this.page,
                limit: this.limit,
            });
        } else {
            this.getFiltersTicketMenu(this.filters);
        }
    }
}
